import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnimationOptions } from 'ngx-lottie';
import * as $ from 'jquery';
import { CleverTapConstents, ConstantData } from 'src/app/services/constants';
import { OtpStatus, RelationsData } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';
import { ValidationService } from 'src/app/services/validation.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-basic-details',
  templateUrl: './basic-details.component.html',
  styleUrls: ['./basic-details.component.scss']
})
export class BasicDetailsComponent implements OnInit, OnDestroy {

  loader:AnimationOptions = {
    path:this.util.redirectionUrl + ConstantData.loader,
  };
  dateChange:Subject<any> = new Subject();
  date: Date | undefined;

  isSponsor: boolean = false;

  genderArray = ConstantData.genderType;
  relations!: RelationsData[];
  otpErrorMsg: string = '';
  emailOtpErrorMsg: string = '';
  mobileOtp: string = '';
  emailOtp: string = '';
  timer: string = '40';
  emailtimer: string = '40';
  emailinterval: any;
  interval: any;
  // emailVerificationWindow: any;
  // emailVerificationWindowCloseListener: any;
  defaultLength:number = ConstantData.panCardLength;
  isValidPan:boolean=false;
  showLoader:any = [];
  loandetails:any;
  isBasicFlow:boolean = false;

  editEmail:boolean = true;
  

  optStatus: OtpStatus = OtpStatus.init;
  emailOptStatus: OtpStatus = OtpStatus.init;

  formSubmitInterval:any;

  setPanStatus(event:boolean){
    this.isValidPan = event;
     const panData = this.util.getCache('panData'); 
     const form = <FormGroup>this.formDetails;
    if(panData){
      form.controls['name'].setValue(panData.name); 
      panData.name?.trim()? form.controls['name'].disable():form.controls['name'].enable();
      if(panData.gender){
        form.controls['genderType'].setValue(this.genderArray.find((val)=> val.label?.toLowerCase() === panData.gender?.toLowerCase() )?.value);
        form.controls['genderType'].value ? form.controls['genderType'].disable():form.controls['genderType'].enable();
      }else{
        form.controls['genderType'].enable();
      }
     
      form.controls['dob'].setValue(panData.dob);
      panData.dob?.trim() ? form.controls['dob'].disable():form.controls['dob'].enable();
      panData.dob?.trim() ? this.dateChange.next(panData.dob): this.dateChange.next(false);
    }else if(this.isValidPan){
      form.controls['genderType'].enable();
      form.controls['dob'].enable();
      form.controls['name'].enable();
    }

  }

  get formatedEmail():string{
    const email = this.formDetails.controls['email'].value;
    if(email.length < 28){
      return email;
    }
    const emailHost = email.split('@')[1];
    const emailId = email.split('@')[0];
    const num = emailId.length - (email.length - 27) - 4;
    return `${emailId.substr(0, num)}...@${emailHost}`;
  }
  get remainingLenth():number{
    return this.formDetails.controls['mobile'].value.length;
  }
  get emailVerified(): boolean {
    return this.emailOptStatus === OtpStatus.verified;
  }
  get showOtpField(): boolean {
    return this.optStatus === OtpStatus.sent || this.optStatus === OtpStatus.resent;
  }
  get showEmailOtpField(): boolean {
    return (this.emailOptStatus === OtpStatus.sent || this.emailOptStatus === OtpStatus.resent) && !this.editEmail;
  }
  get numberVerified(): boolean {
    return this.optStatus === OtpStatus.verified;
  }

  get otpInit(): boolean {
    return this.optStatus === OtpStatus.init;
  }
  get emailOtpInit(): boolean {
    return this.emailOptStatus === OtpStatus.init;
  }

  get isFormValid() {
    return this.formDetails.valid && this.emailVerified && this.numberVerified && this.isValidPan;
  }
  // get disableForm(){
  //   return !this.isValidPan &&  this.formDetails.disable();
  // }

  formDetails: any = new FormGroup({
    'relationId': new FormControl('', [Validators.required,]),
    'name': new FormControl('', [Validators.required]),
    'email': new FormControl('', [Validators.required, this.validators.emailValidator.bind(this)]),
    'mobile': new FormControl('', [Validators.required, this.validators.phoneNumberValidator.bind(this)]),
    'dob': new FormControl('', [Validators.required, this.validators.dateValidator.bind(this, true)]),
    'genderType': new FormControl('', [Validators.required,]),
    'relationValue': new FormControl(''),
    

  });
  title:string = '';
  constructor(private validators: ValidationService, public util: UtilService) { }

  ngOnInit(): void {
    this.init();
   this.util.userLoggedInEventCalled.subscribe(this.init.bind(this));
  }
  init(){
    
    this.loandetails = this.util.loanDetails;
    if(!this.loandetails ){
      return;
    }

    
    this.util.setCache('kycTab' , 'basic');
    localStorage.setItem('isSponser', '0');
    localStorage.setItem('emailVerified', '0');
    this.isSponsor = this.util.loanDetails.isSponser;
    this.relations = this.util.relations?.filter((relation: RelationsData) => relation.value === "Parent" || relation.value === "Gaurdian" || this.isSponsor && relation.value === "Spouse");
    this.title = !this.util.getCurrentApplicant.mainApplicant ? 'Co-applicant' :this.isSponsor?'Sponsor':'Applicant'
    this.isBasicFlow = !this.loandetails?.isStudentMainApplicant || this.loandetails?.isSponser || !this.util.getCurrentApplicant.mainApplicant;

    this.formSubmitInterval = 
      setInterval(() => {
      
        if(this.isFormValid){
          clearInterval(this.formSubmitInterval);
          this.submit();
        }
      },2000);

    setTimeout(()=>{
      this.formDetails.controls['name'].disable();
      this.formDetails.controls['genderType'].disable();
      this.dateChange.next({});
    })

   }

  getGenderLabel(){
    return this.genderArray.find((e)=> e.value == this.formDetails.controls['genderType'].value)?.label || '';
  }

  getRelationLabel(){
    return this.relations?.find((e)=> e.id === this.formDetails.controls['relationId'].value)?.value || '';
  }
  
  onPhoneNumberInput(event: any, isPhoneNUmber: boolean = true, isEmail: boolean = false) {
    const numericInput = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = numericInput;
    isPhoneNUmber && this.formDetails.controls[isEmail ? 'email' : 'mobile'].setValue(numericInput);
    
  }

  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }

  handleOtp(event: any, isEmail: boolean = false) {
    
    const otpField: any = Array.from(document.querySelectorAll(`.otp-inputs.${isEmail ? 'email' : 'mobile'} .cus-input`));
    const index = otpField.findIndex((el: any) => el === event.target);
    !isEmail ? (this.otpErrorMsg = '') : (this.emailOtpErrorMsg = '');
    if (index < 5 && index !== -1 && event.target.value.length) {
      otpField[index + 1].focus();
    } else if (index > 0 && !event.target.value.length) {
      otpField[index - 1].focus();
    }
    const otp = otpField.map((el: any) => el.value).join('');

    !isEmail ? (this.mobileOtp = otp) : (this.emailOtp = otp);
    if (!isEmail ? (this.mobileOtp.length === 6) : (this.emailOtp.length === 6)) {
      this.verifyOtp(isEmail)
    }

  }

  sendOtp(isEmail: boolean = false) {
    if (isEmail) {

      return;
    }
    document.querySelectorAll(`.otp-inputs.${isEmail ? 'email' : 'mobile'} .cus-input`).forEach((data:any)=>{
      data.value = '';
    })
    this.otpErrorMsg = '';
    this.mobileOtp = '';
    const currentApplicant = this.util.getCurrentApplicant;
    const loanData = this.util.loanDetails;
     this.showLoader.push('mobile');
    this.util.handleRequests('get', this.util.getUrl('loan_mobileNumber_otp', [loanData.loanId, currentApplicant.id, this.formDetails.value['mobile']]),undefined,undefined,undefined,undefined,false).then(() => {
      this.optStatus = OtpStatus.sent;
      this.runTimer();
      this.showLoader =  this.showLoader.filter((s:any)=> s != 'mobile');
    }).catch(()=>{
      this.optStatus = OtpStatus.init;
      this.showLoader =  this.showLoader.filter((s:any)=> s != 'mobile');
    })


  }

  runTimer(isEmail: boolean = false) {
    if (isEmail) {
      this.emailtimer = '40';
      clearInterval(this.emailinterval);
      this.emailinterval = setInterval(() => {
        this.emailtimer = (+this.emailtimer - 1).toString().padStart(2, '0');
        if (this.emailtimer === '00') {
          clearInterval(this.emailinterval);
        }
      }, 1000);
    } else {
      this.timer = '40';
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.timer = (+this.timer - 1).toString().padStart(2, '0');
        if (this.timer === '00') {
          clearInterval(this.interval);
        }
      }, 1000);
    }
  }

  verifyOtp(isEmail: boolean = false) {
    const currentApplicant = this.util.getCurrentApplicant;
    const loanData = this.util.loanDetails;
    if (isEmail) {
      this.util.handleRequests('put', this.util.getUrl('pan_email_otpVerification'), {
        "loanId": loanData.loanId,
        "applicantId": currentApplicant.id,
        "emailId": this.formDetails.value['email'],
        "otp": this.emailOtp

      },undefined,undefined,undefined,false,false).then((res: any) => {
        this.emailOptStatus = OtpStatus.verified;
      }).catch((err: any) => {

        this.emailOtpErrorMsg = err.msg;

      });

      return;
    }
    this.util.handleRequests('put', this.util.getUrl('loan_mobileNumber_verify', [loanData.loanId, currentApplicant.id, this.formDetails.value['mobile'], this.mobileOtp]),undefined,undefined,undefined,undefined,false).then((res: any) => {

      this.optStatus = OtpStatus.verified;
    }).catch((err: any) => {

      this.otpErrorMsg = err.msg;

    });


  }

  emailVerification() {
    document.querySelectorAll(`.otp-inputs.email .cus-input`).forEach((data:any)=>{
      data.value = '';
    });
    this.editEmail = false;
    this.emailOtp = '';
    this.emailOtpErrorMsg = '';
    const currentApplicant = this.util.getCurrentApplicant;
    const loanData = this.util.loanDetails;
    this.showLoader.push('email');
    this.util.handleRequests('put', this.util.getUrl('loan_validate_email',[loanData.loanId, currentApplicant.id,this.formDetails.value['email']]),undefined,undefined,undefined,false,false).then(()=>{
    this.util.handleRequests('post', this.util.getUrl('pan_email_verification'), {
      "loanId": loanData.loanId,
      "applicantId": currentApplicant.id,
      "emailId": this.formDetails.value['email']
    },undefined,undefined,undefined,false,false).then((res: any) => {
      if (res.status === 'SUCCESS') {
        this.emailOptStatus = OtpStatus.sent;
        
        this.runTimer(true);
      } else {
        this.emailOtpErrorMsg = 'Something went wrong';

      }
      this.showLoader =  this.showLoader.filter((s:any)=> s != 'email');

    }).catch((err: any) => {

      this.emailOtpErrorMsg = err.msg;
      this.showLoader =  this.showLoader.filter((s:any)=> s != 'email');

    });
  }).catch((err:any)=>{
    this.emailOtpErrorMsg = err.msg;
    this.showLoader =  this.showLoader.filter((s:any)=> s != 'email');
  });

  }

  submit() {
    const data = this.formDetails.getRawValue();
    data['mobile'] = `+91${data['mobile']}`
    const loanDetails = this.util.loanDetails;
    const currentApplicant = this.util.getCurrentApplicant;
    const body = { ...data, relationValue: this.relations?.find((relation: any) => relation.id === data.relationId)?.value, 'pan': this.util.getCache('panNumber') || loanDetails.panInfo.pan, dob: this.util.formatDate(data.dob, ConstantData.candidateDobFormate) };
    this.util.handleRequests('put', this.util.getUrl('loan_pan', [loanDetails.loanId, currentApplicant.id]), body).then((res) => {
      this.util.getProducts().then(() => {
        this.util.navigationHandler();
      })
    });

  }
  edit(val:string){
    if(val==='email'){
      this.emailOptStatus = OtpStatus.init;
    }
  else this.optStatus = OtpStatus.init;
  }

  ngOnDestroy(): void {
    localStorage.setItem('emailVerified', '0');
    localStorage.setItem('isSponser', '0');
    // this.emailVerificationWindow.close();
    clearInterval(this.interval);
    // clearInterval(this.emailVerificationWindowCloseListener);
    clearInterval(this.formSubmitInterval);
    clearInterval(this.emailinterval);
  }

}
